import React from 'react';
import PropTypes from 'prop-types';
import TcDayPicker from '../../../tc-ui/date-picker';

const ContractingYear = ({
  endDate,
  endDateError,
  onChange,
  startDate,
  startDateError,
  style,
}) => (
  <div style={style}>
    <div>
      <b>What dates would you like the rates to be valid for?</b>
      <small style={{ color: 'red' }}>* Required</small>
    </div>
    <TcDayPicker
      data-cy="startDate"
      containerStyle={{ float: 'left', display: 'inline-block', verticalAlign: 'top' }}
      textFieldStyle={{ float: 'left', width: '100%', fontSize: '12px' }}
      errorText={startDateError}
      onChange={date => onChange({ key: 'startDate', value: date })}
      initialMonth={startDate || endDate}
      value={startDate}
      floatingLabelText="Start Date"
      closeOnSelect
    />
    <TcDayPicker
      data-cy="endDate"
      containerStyle={{
        float: 'left', marginLeft: '32px', display: 'inline-block', verticalAlign: 'top',
      }}
      textFieldStyle={{ float: 'left', width: '100%', fontSize: '12px' }}
      errorText={endDateError}
      onChange={date => onChange({ key: 'endDate', value: date })}
      floatingLabelText="End Date"
      initialMonth={endDate || startDate}
      value={endDate}
      closeOnSelect
    />
    <br />
  </div>
);

ContractingYear.propTypes = {
  style: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  startDateError: PropTypes.string,
  endDateError: PropTypes.string,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};

export default ContractingYear;



// WEBPACK FOOTER //
// ./src/app/components/contracting/buyer-wizard/contract-settings/contracting-year.jsx